import { z } from 'zod';
import { VerificationErrorSchema, VerificationStateSchema, VerificationTypeSchema } from '../verifications/verifications.schema';

export const KycDtoSchema = z.object({
  token: z.string(),
});

// Used for socket events
export const KYCStatusMessageSchema = z.object({
  userId: z.string().uuid(),
  type: VerificationTypeSchema,
  state: VerificationStateSchema,
  error: VerificationErrorSchema.nullish(),
});

export const KycDuplicateAccountHintPayloadSchema = z.object({
  userId: z.string(),
  matchedApprovedEmail: z.string().min(1),
});

export type KYCStatusMessage = z.infer<typeof KYCStatusMessageSchema>;
export type KycDuplicateAccountHintPayload = z.infer<typeof KycDuplicateAccountHintPayloadSchema>;
export type KYCStates = z.infer<typeof VerificationStateSchema>;
